import { ROLE_ACCESS } from '@/constant/storage';
import { routerToBack } from '@/helpers/checkRouterPrevPath';
import { PATH_NAME } from 'configs/pathName';
import { PostContext } from 'context/PostContext';
import Button from 'design-system/components/Button/Button';
import { Divider } from 'design-system/components/Divider';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { forwardRef, useContext } from 'react';
import PostBookmarkButton from './floating-post-interaction-menu/PostBookmarkButton';
import PostCommentButton from './floating-post-interaction-menu/PostCommentButton';
import PostControlMenuButton from './floating-post-interaction-menu/PostControlMenuButton';
import PostReactButton from './floating-post-interaction-menu/PostReactButton';
import PostShareButton from './floating-post-interaction-menu/PostShareButton';
const Tooltips = dynamic(
  () => import('design-system/components/Tooltips/Tooltips')
);

const FloatingPostInteractionMenu = forwardRef<HTMLDivElement, {}>(function Foo(
  props,
  ref
) {
  const router = useRouter();
  const { group, ...postInfo } = useContext(PostContext);

  const navigateGroup = () => (group ? router.push(group.slug) : undefined);

  return (
    // https://stackoverflow.com/questions/44446671/my-position-sticky-element-isnt-sticky-when-using-flexbox => using self-start
    <div className="fixed bottom-4 left-0 z-10 flex h-fit w-full transform justify-center xl:sticky xl:left-0 xl:top-[66px] xl:w-fit xl:transform-none">
      <div
        ref={ref}
        className="flex gap-2 self-start rounded-full border border-Primary/Other(Border) bg-Other/White p-[6px] px-2 xl:flex-col xl:gap-3 xl:border-none xl:bg-transparent xl:py-10"
      >
        <Tooltips title={'Quay về'}>
          <Button
            onClick={() => routerToBack(router, PATH_NAME.HOME)}
            size="medium"
            mode="icon-only"
            emphasis="medium"
            className="hidden xl:block"
            icon={{
              name: 'arrow-right-md',
            }}
          />
        </Tooltips>
        <Divider type="horizontal" className="hidden xl:block" />
        <PostReactButton />
        <PostCommentButton navigateGroup={navigateGroup} />
        <PostBookmarkButton />
        <PostShareButton />
        {(postInfo.isOwner || group?.userRole === ROLE_ACCESS.Owner) && (
          <PostControlMenuButton />
        )}
      </div>
    </div>
  );
});

export default FloatingPostInteractionMenu;
